import moment from "moment";
import React from "react";
import styled from "styled-components";

import Colors from "../../../shared/colors";
import LocalStorage from "../../../shared/localStorage";

const Layout = styled.div`
  .patient-details {
    margin-top: 25px;
    margin-bottom: 10px;

    .label {
      color: ${Colors.aquaDeep};
    }
  }
`;

const InfoPAF = ({ patientDetails, registerPatient, isRenewal }) => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const truncateAddress = (address) => {
    return address?.split(",")[0] || "";
  };

  const populateTreatingHospital = () => {
    if (!isRenewal) {
      return (
        truncateAddress(patientDetails?.hospital) ||
        truncateAddress(registerPatient?.name_and_address_hospital) ||
        (truncateAddress(patientDetails?.treatingHospital) ??
          patientDetails?.hospital)
      );
    } else {
      return parseLocalStorage?.hospital?.name;
    }
  };
  return (
    <Layout>
      <div className="wrapper-flex patient-details row">
        <div className="col col-sm-6-custom">
          <div className="label">Patient Initials:</div>
          <div className="font-size-16">{patientDetails?.initial_name}</div>
        </div>
        <div className="col col-sm-6-custom">
          <div className="label">Gender:</div>
          <div className="font-size-16">{patientDetails?.gender}</div>
        </div>
        <div className="col col-sm-6-custom">
          <div className="label">Date of Birth:</div>
          <div className="font-size-16">
            {patientDetails?.dob &&
              moment(patientDetails?.dob).format("DD / MM / YY")}
          </div>
        </div>
        <div className="col col-sm-6-custom">
          <div className="label">Treating Hospital:</div>
          <div className="font-size-16">{populateTreatingHospital()}</div>
        </div>
      </div>
    </Layout>
  );
};
export default InfoPAF;
